import types from './all-mutation-types'
import Vue  from 'vue'
import axios from 'axios'
import {router} from '@/main'
import { MutationTree } from 'vuex/types'
import { IAuthState } from './state'
import {resetState, loadInitalData} from '@/store'
import { calculSecurityRights } from '@/enum/SecurityItems'
import { getDefaultAloUser } from '@/models/alo/AloUser'

const mutations: MutationTree<IAuthState> = {
  [types.AUTH_REQUEST]: state => {
    state.authStatus = 'AuthenticationProgress'
  },
  [types.AUTH_SUCCESS]: state => {
    //on s'assure que le state est résété pour le nouvel utilisateur connecté    
    resetState()  
    loadInitalData()
    state.authStatus = 'AuthenticationSuccess'    
  },
  [types.AUTH_ERROR]: (state, message) => {
    state.authStatus = message || 'AuthenticationError'
  },
  [types.AUTH_LOGOUT_REQUEST]: state => {    
    //state.authStatus = 'LogoutProgress'            
  },
  [types.AUTH_LOGOUT_SUCCESS]: state => {    
    //state.authStatus = 'LogoutSuccess'
    resetState()    
    loadInitalData()            
    if(router.currentRoute.name != null && router.currentRoute.name != "Login" && router.currentRoute.name != "Home" && router.currentRoute.name != "CreatePassword") router.push({name:"Home"})          
  },  
  [types.AUTH_LOGOUT_ERROR]: state => {    
    //state.authStatus = 'LogoutError'                
  },
  [types.AUTH_USER_REQUEST]: state => {
    state.userStatus = 'loading'
  },
  [types.AUTH_USER_SUCCESS]: (state, user) => {
    state.userStatus = 'success'    
    state.user = {...getDefaultAloUser(),...user}    
    state.userSecurity = calculSecurityRights()        
  },
  [types.AUTH_USER_ERROR]: state => {
    state.userStatus = 'error'
  },
  [types.AUTH_PASSWORD_REQUEST]: state => {
    state.authStatus = 'PassForgottenProgress'
  },
  [types.AUTH_PASSWORD_SUCCESS]: state => {        
    state.authStatus = 'PassForgottenSuccess'
  },
  [types.AUTH_PASSWORD_ERROR]: (state, message) => {
    state.authStatus = message || 'PassForgottenError'
  },
  [types.AUTH_CHANGE_PASSWORD_REQUEST]: state => {
    state.authStatus = 'ChangePasswordProgress'
  },
  [types.AUTH_CHANGE_PASSWORD_SUCCESS]: state => {        
    state.authStatus = 'ChangePasswordSuccess'
  },
  [types.AUTH_CHANGE_PASSWORD_ERROR]: (state, message) => {
    state.authStatus = message || 'ChangePasswordError'
  },
  [types.AUTH_CREATE_PASSWORD_REQUEST]: state => {
    state.authStatus = 'CreatePasswordProgress'
  },
  [types.AUTH_CREATE_PASSWORD_SUCCESS]: state => {        
    state.authStatus = 'CreatePasswordSuccess'
  },
  [types.AUTH_CREATE_PASSWORD_ERROR]: (state, message) => {
    state.authStatus = message || 'CreatePasswordError'
  },  
  [types.AUTH_RESET_STATUS]: (state) => {
    state.authStatus = ''
  },
  [types.AUTH_SET_REDIRECT_PATH]: (state,path:string) => {
    state.redirectPath = path
  },

}

export default mutations
